var Tools = require('./tools');
/*
  Feedbackify form support

  @requires Feedbackify initialization
  @param options (object)
    autoStart (boolean) auto show the feedback modal
    email (string) user's email address to include in form
    form (string) form name feedback|switched
    locale (string) the current site locale
    tab (bool) show the feedback tab
    userType (string) the type of user for inclusion in the feedback form
    target (element) jQuery element
*/
module.exports = function(options) {

  var self = {};

  self.mergeParams = Tools.mergeParams; // implements

  self.options = {
    autoStart: false,
    email: false,
    form: 'feedback',
    tab: true,
    userType: false
  };

  // form locale to id map
  self.form = {
    feedback: {
      'en': 2393, // 3.0 Feedback - English
      'fr': 2406, // 3.0 Feedback - French
      'it': 2421, // 3.0 Feedback - Italian
      'de': 3547, // 3.0 Feedback - German
      'es': 8449, // 3.0 Feedback - Spanish
      'nl': 8664,  // 3.0 Feedback - Dutch
      'pt': 16007, // 3.0 Feedback - Portuguese
      'pl': 16016 // 3.0 Feedback - Polish
    },
    switched: {
      'en': 2405, // Switched back to 2.0 - English
      'fr': 2407, // Switched back to 2.0 - French
      'it': 2422, // Switched back to 2.0 - Italian
      'de': 3548, // Switched back to 2.0 - German
      'es': 2405, // Switched back to 2.0 - Spanish Using English
      'nl': 2405,  // Switched back to 2.0 - Dutch Using English
      'pt': 16049, // Switched back to 2.0 - Portuguese
      'pl': 16050 // Switched back to 2.0 - Polish
    },
    publicPage: {
      'en': 3533, // Consumer App Public Feedback - English
      'fr': 3544, // Consumer App Public Feedback - French
      'it': 3545, // Consumer App Public Feedback - Italian
      'de': 3546, // Consumer App Public Feedback - German
      'es': 8451, // Consumer App Public Feedback - Spanish
      'nl': 8666,  // Consumer App Public Feedback - Dutch
      'pt': 16045,  // Consumer App Public Feedback - Portuguese
      'pl': 16046  // Consumer App Public Feedback - Polish
    },
    myEnlighten: {
      'en': 4512, // Consumer App Authenticated Feedback - English
      'fr': 4513, // Consumer App Authenticated Feedback - French
      'it': 4515, // Consumer App Authenticated Feedback - Italian
      'de': 4514, // Consumer App Authenticated Feedback - German
      'es': 8450, // Consumer App Authenticated Feedback - Spanish
      'nl': 8665, // Consumer App Authenticated Feedback - Dutch
      'pl': 16044, // Consumer App Authenticated Feedback - Polish
      'pt': 16043 // Consumer App Authenticated Feedback - Portuguese
    },
    arrayBuilder: {
      'en': 13525, // New Array Builder Feedback - English
      'fr': 13526, // New Array Builder Feedback - French
      'it': 13528, // New Array Builder Feedback - Italian
      'de': 13527, // New Array Builder Feedback - German
      'es': 13529, // New Array Builder Feedback - Spanish
      'nl': 13524, // New Array Builder Feedback - Dutch
      'pt': 16047,  // New Array Builder Feedback - Portuguese
      'pl': 16048  // New Array Builder Feedback - Polish
    },
    test: {
      'en': 2674
    }
  };

  // system initialization
  self.init = function() {
    options = self.mergeParams(self.options, options);
    self.setFormId();
    if (options.tab) self.enableTab();
    if (options.autoStart) self.showForm();
  };

  self.setFormId = function() {
    self.formId = self.form[options.form][options.locale];
  };

  self.enableTab = function() {
    options.target.click(self.showForm);
  };

  self.showForm = function(event) {
    event && event.stopPropagation();
    FBY.showForm(self.formId);
    if (self.options.email) FBY.setEmail(self.options.email);
    self.interceptSubmit();
  };

  self.interceptSubmit = function() {
    // button isn't instantiated until animation is complete
    // this can take some time on a page with a long load time
    setTimeout(function() {
      var submit = $('#feedbackify .fsend');
      if (!submit.length) {
        // button isn't available yet retry
        self.interceptSubmit();
      } else {
        submit.bind('mouseup', self.prependData);
      }
    }, 100);
  };
  
  self.prependData = function() {
    var textarea = $('#feedbackify textarea'),
        container = $('#feedbackify .feedback-holder'),
        value = textarea.val();

    container.hide();
    value = '{{' + self.options.userType + '}}\n--\n' + value;
    textarea.val(value);
  };

  self.init();

  return self;

};
